import { render, staticRenderFns } from "./comp_MainCarousel.vue?vue&type=template&id=2b41851a&scoped=true&"
import script from "./comp_MainCarousel.vue?vue&type=script&lang=js&"
export * from "./comp_MainCarousel.vue?vue&type=script&lang=js&"
import style0 from "./comp_MainCarousel.vue?vue&type=style&index=0&id=2b41851a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b41851a",
  null
  
)

export default component.exports